const INSTAGRAM_RECONNECT_CODES = new Set([
  'instagram_credentials_missing',
  'instagram_not_connected',
  'token_expired',
]);

export const classifyInstagramConnectionError = (error) => {
  const code = error?.response?.data?.code || '';

  return {
    code,
    requiresReconnect: INSTAGRAM_RECONNECT_CODES.has(code),
  };
};

export const invalidateInstagramUserSnapshot = (user) => {
  if (!user || !['creator', 'business'].includes(user.user_type)) return user;

  const profileKey = user.user_type === 'business' ? 'business_profile' : 'creator_profile';
  const profile = user[profileKey];
  if (!profile || profile.instagram_account_connected === false) return user;

  return {
    ...user,
    [profileKey]: {
      ...profile,
      instagram_account_connected: false,
    },
  };
};
